import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, ConnectedProps, connect, useSelector } from 'react-redux';
import { IForgotPasswordRequest } from 'Data/interfaces/Auth/IForgotPasswordRequest';
import { AuthActions } from 'Store/Auth/Auth.actions';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { getDomain } from 'Store/MultiDomain/MultiDomain.selector';
import schema from './forgotPassword.schema';
import BoxContainer from 'Components/UI/Containers/BoxContainer/BoxContainer';
import Button from 'Components/UI/Button';
import Form from 'Components/UI/Form/Form';
import Field from 'Components/UI/Field';
import Link from 'Components/UI/Link';
import Background from '../Backgroud/background';
import styles from './ForgotPassword.module.scss';

const ForgotPassword: FC<Props> = (props) => {
  const { t } = useTranslation('auth');
  const dispatch = useDispatch();
  const domain = useSelector(getDomain);

  const signup = (data: IForgotPasswordRequest) => {
    dispatch(AuthActions.userForgotPassword(data));
  };

  return (
    <Background>
      <BoxContainer height={domain?.LogoUrl ? 300 : 251} width={403}>
        <div className={styles['contentWrapper']}>
          <h2 className={styles['title']}>{t('forgotPassword.title')}</h2>
          <Form schema={schema} onSubmit={signup}>
            <Field
              name='email'
              label={t('common:email')}
              icon='arroba'
              placeholder={t('signup.emailPlaceholder')}
            />
            <div className={styles['buttonWrapper']}>
              <Button
                width='100%'
                type='primary'
                htmlType='submit'
                loading={props.isLoading}
              >
                {t('forgotPassword.submitButton')}
              </Button>
            </div>
          </Form>

          <div className={styles['backLoginWrapper']}>
            <Link to='/login'>
              {t('forgotPassword.backToLogin')}
            </Link>
          </div>

          {domain?.LogoUrl && (
            <p className={styles['powered-by']}>
              Powered by <span>Coordly</span>
            </p>
          )}
        </div>
      </BoxContainer>
    </Background>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.auth,
});

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

export default connector(ForgotPassword);
